/**
 * Cursor Simple Browser can inject an empty full-viewport iframe
 * (z-index 2147483647, pointer-events: auto) that blocks all clicks.
 * Neutralize only that tooling overlay — leave real app iframes alone.
 */
export function neutralizeCursorOverlayIframes(): number {
  let neutralized = 0;
  document.querySelectorAll('iframe').forEach(iframe => {
    const cs = window.getComputedStyle(iframe);
    const r = iframe.getBoundingClientRect();
    const src = iframe.getAttribute('src') || '';
    const isFullBleed =
      cs.position === 'fixed' &&
      r.width >= window.innerWidth * 0.9 &&
      r.height >= window.innerHeight * 0.9;
    const isCursorOverlay =
      cs.zIndex === '2147483647' ||
      (iframe.getAttribute('style') || '').includes('2147483647');
    if (
      isFullBleed &&
      isCursorOverlay &&
      (!src || src === 'about:blank') &&
      cs.pointerEvents !== 'none'
    ) {
      iframe.style.setProperty('pointer-events', 'none', 'important');
      neutralized += 1;
    }
  });
  return neutralized;
}

/** Start observer + interval; returns cleanup. */
export function startCursorOverlayNeutralize(): () => void {
  neutralizeCursorOverlayIframes();
  const observer = new MutationObserver(() => {
    neutralizeCursorOverlayIframes();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });
  const intervalId = window.setInterval(neutralizeCursorOverlayIframes, 250);
  return () => {
    observer.disconnect();
    window.clearInterval(intervalId);
  };
}
